import axios from 'axios';
import { client } from '@/services/api/axios.ts';
import { useQuery } from '@tanstack/react-query';
import { TDevices } from '@/features/devices/schemas/devices.schemas.ts';

export async function getAllDevices(): Promise<TDevices | undefined | never> {
  try {
    const { data } = await client.get(`/devices`);

    return data.body;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(`${error?.response?.data?.message}`);
    }

    if (error instanceof Error) {
      throw new Error(`${error.message}}`);
    }
  }
}

export const useGetDevicesQuery = () => {
  return useQuery({
    queryKey: ['devices'],
    queryFn: getAllDevices,
    retry: 1,
  });
};
